import { serializeQuery, type QueryObject } from '@/shared/lib/serializeQuery';
import { block } from './toUrl/block';
import { checkInDateRange } from './toUrl/checkInDateRange';
import { directFlight } from './toUrl/directFlight';
import type { SearchCriteria, PartialSearchCriteria } from '../model/types';
import { fromCity } from './toUrl/fromCity';
import { hotelCategories } from './toUrl/hotelCategories';
import { hotels } from './toUrl/hotels';
import { meals } from './toUrl/meals';
import { nightRange } from './toUrl/nightRange';
import { resorts } from './toUrl/resorts';
import { toCountry } from './toUrl/toCountry';
import { touristGroup } from './toUrl/touristGroup';

export function toSearchCriteriaQuery(criteria: SearchCriteria | PartialSearchCriteria): QueryObject {
  return {
    ...fromCity(criteria),
    ...toCountry(criteria),
    ...resorts(criteria),
    ...checkInDateRange(criteria),
    ...nightRange(criteria),
    ...touristGroup(criteria),
    ...hotelCategories(criteria),
    ...meals(criteria),
    ...hotels(criteria),
    ...directFlight(criteria),
    ...block(criteria),
  };
}

export function getToursUrl(criteria: SearchCriteria | PartialSearchCriteria, otherCriteria: QueryObject = {}): string {
  return serializeQuery({ ...toSearchCriteriaQuery(criteria), ...otherCriteria });
}
